import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { ProcessRatesPopUp } from './ProcessRatesTable';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class ProcessRatesItemWise extends Component {
    constructor(props) {
        super(props)
        this.masterEntryServices = new MasterEntryServices();
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isTable2Expanded: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            processObject: {
                //selectType: "",
                //vendor: "",
                idItemCategory: 0,
                itemCategoryList: [],
                idProcess: "",
                processList: [],
                processColdefs: [],
                processRowData: [],
                processSelectedColdefs: [],
                processSelectedRowData: [],
                activeTab: "pending",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                idProcess: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "process"
                        ),
                    },
                ],
                // idItemCategory: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "item category"
                //         ),
                //     },
                // ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
            // this.getMasterExpenseAccGroupCount();
        })
    };

    onRowDoubleClicked = (event) => {
        // if (!this.state.permissions.isAddEdit) {
        //     this.SwalServices.Error(permission.edit);
        //     return;
        // }
        // let validState = this.state.validState;
        // validState.isValid = true;
        // validState.error = {};
        // this.setState({
        //     validState: validState,
        //     isModalOpen: true
        // });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.processObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.processObject;
        details[name] = value;
        this.setState({ processObject: details });
    }

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let processObject = this.state.processObject;
        processObject.idItemCategory = "";
        processObject.idProcess = "";
        processObject.processColdefs = [];
        processObject.processRowData = [];
        processObject.processSelectedColdefs = [];
        processObject.processSelectedRowData = [];
        processObject.activeTab = "pending";
        this.setState({
            processObject: processObject, validState: validState
        });
    }

    setActiveProcessTab = (tab) => {
        let details = this.state.processObject;
        details.activeTab = tab;
        this.setState({ processObject: details });
    }

    onSelectedRowDoubleClicked = (event) => {
        // If the double-click landed on the editable itemRate cell, edit it instead of prompting delete
        const focusedCell = event.api && event.api.getFocusedCell();
        if (focusedCell && focusedCell.column && focusedCell.column.getColId() === "itemRate") {
            return;
        }
        if (!this.state.permissions.isDelete) {
            this.SwalServices.Error(permission.delete);
            return;
        }
        let row = event.data;
        this.SwalServices
            .Confirm("Delete Process Rate", "Are you sure you want to delete this?", "Okay", "Cancel")
            .then((response) => {
                if (response) {
                    let request = [
                        this.state.processObject.idProcess,
                        row.idItem,
                        this.state.idCompany,
                    ];
                    this.masterEntryServices.deleteItemRateProcesswise(request).then((response) => {
                        if (response.statusCode === 200 && response.responseItem !== null) {
                            let data = this.state.processObject;
                            data.processSelectedRowData = data.processSelectedRowData.filter(
                                (x) => x.idItem !== row.idItem
                            );
                            this.setState({ processObject: data }, () => {
                                this.SwalServices.Success("Deleted successfully.");
                                this.procSelectAllRecordsSP();
                            });
                        }
                    });
                }
            });
    }

    handleChangeFroDropdown = (event, name) => {
        //debugger;
        let details = this.state.processObject;
        let value = event.value;
        details[name] = value;
        this.setState({ processObject: details });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.getAllDropdownForStockMaster();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Process Rates Item Wise",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idProcessRatesItemWise"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            // valueFormatter: key.includes("date") || key.includes("invoiceDate")
                            //   ? (params) => {
                            //     if (!params.value) return "";
                            //     return moment(params.value).format("DD-MM-YYYY");
                            //   }
                            //   : undefined,
                            //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                        }));
                        //const priorityColumn = "bankName"; // Replace with the actual column name
                        //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
                        //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
                        //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

                        // const updatedColDefs = [
                        //   ...pinnedColumns,
                        //   ...(priorityColDef ? [priorityColDef] : []),
                        //   ...otherColumns,
                        // ];
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs, //updatedColDefs,
                            caption: "Process Rates Item Wise",
                            colName: colName
                        }, () => {
                            //this.procSelectAllRecord2GridviewSP(id, "Advance Withdraw");
                            //this.getAllDropdownForEmployeeMaster();
                            this.setPermissions(permissions);
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.05,
            "itemCategory": window.innerWidth * 0.15,
            "itemGroup": window.innerWidth * 0.15,
            "itemName": window.innerWidth * 0.25,
            "process": window.innerWidth * 0.1,
            "processRate": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }
    getColumnWidth2 = (key) => {
        const colwidth = {
            "Select": window.innerWidth * 0.06,
            "drawingNo": window.innerWidth * 0.15,
            "searchText": window.innerWidth * 0.1,
            "itemName": window.innerWidth * 0.2,
            "itemRate": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    getAllDropdownForStockMaster = () => {
        this.masterEntryServices.getAllDropdownForStockMaster(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.processObject;
                data.itemCategoryList = allData.filter(item => item.source === 'All_Master_ItemCategory');
                data.itemCategoryList.map((x) => {
                    x.label = x.label + ' - ' + x.name2
                });
                data.processList = allData.filter(item => item.source === 'Master_Process');
                this.setState({
                    processObject: data,
                });
            }
        });
    }

    getMasterItemSelectForProcessRateRev = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let request = [
                this.state.idCompany,
                this.state.processObject.idProcess,
                0,
            ];

            this.masterEntryServices.getMasterItemSelectForProcessRateRev(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let allData = response.responseItem.responseContent;

                    if (allData.length > 0) {
                        let data = this.state.processObject;

                        // Add srNo and default Select value
                        allData.map((x, key) => {
                            x.srNo = key + 1;
                            x.Select = false;
                        });

                        // Split rows based on the isSelected flag coming from the API
                        const isFlagTrue = (val) => val === true || val === 1;
                        const selectedData = allData.filter((x) => isFlagTrue(x.isSelected));
                        const pendingData = allData.filter((x) => !isFlagTrue(x.isSelected));

                        const columnPriority = [
                            "Select", "drawingNo", "searchText", "itemName", "itemRate",
                        ];

                        const allKeys = Object.keys(allData[0]);
                        const sortedKeys = allKeys.sort((a, b) => {
                            const indexA = columnPriority.indexOf(a);
                            const indexB = columnPriority.indexOf(b);
                            if (indexA === -1 && indexB === -1) return 0;
                            if (indexA === -1) return 1;
                            if (indexB === -1) return -1;
                            return indexA - indexB;
                        });

                        const buildColDefs = (showSelectCheckbox) =>
                            sortedKeys.map((key) => {
                                const isSelectColumn = key === "Select";
                                // In the Selected tab (showSelectCheckbox === false) the item rate is editable
                                const isEditableRateColumn = key === "itemRate" && !showSelectCheckbox;
                                return {
                                    field: key.includes(".") ? key.replace(/\./g, "_") : key,
                                    headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                                    minWidth: this.getColumnWidth2(key) !== undefined
                                        ? this.getColumnWidth2(key)
                                        : window.innerWidth * 0.06,
                                    flex: 1,
                                    filter: true,
                                    floatingFilter: true,
                                    // In the Selected tab the Select checkbox column is not needed
                                    hide: ["idItem", "srNo", "itemCategory", "itemCategoryDesc", "isSelected"].includes(key) || (isSelectColumn && !showSelectCheckbox) ? true : false,
                                    width: this.getPinnedWidth(key),
                                    ...(isSelectColumn && {
                                        cellRenderer: 'agCheckboxCellRenderer',
                                        editable: showSelectCheckbox,
                                    }),
                                    ...(isEditableRateColumn && {
                                        editable: true,
                                        cellClass: 'editable-rate-cell',
                                        valueParser: (params) => {
                                            const parsed = Number(params.newValue);
                                            return isNaN(parsed) ? params.oldValue : parsed;
                                        },
                                    }),
                                };
                            });

                        // Update state
                        data.processRowData = pendingData;
                        data.processColdefs = buildColDefs(true);
                        data.processSelectedRowData = selectedData;
                        data.processSelectedColdefs = buildColDefs(false);
                        data.activeTab = "pending";
                        this.setState({
                            processObject: data,
                        });
                    }
                }
            });
        }
    };

    onPopupGridReady = (params) => {
        this.popupGridApi = params.api;
    }

    onCellValueChanged = (event) => {
        // Flag rows in the Selected tab whose item rate was edited so save() can persist them
        if (event.colDef.field === "itemRate") {
            event.data.isRateEdited = true;
        }
    }

    save = () => {
        // Commit any cell that is still in edit mode so the edited itemRate is captured before saving
        if (this.popupGridApi) {
            this.popupGridApi.stopEditing();
        }
        let request = [];
        let data = this.state.processObject;
        data.processRowData.map((x) => {
            if (x.Select === true) {
                let obj = {
                    date: new Date().toISOString(),
                    idProcess: data.idProcess,
                    idItem: x.idItem,
                    processRate: x.itemRate,
                    idCompany: this.state.idCompany,
                    e_Date: new Date().toISOString(),
                };
                request.push(obj);
            }
        });
        // Persist edited item rates from the Selected tab (upsert via the same insert proc)
        data.processSelectedRowData.map((x) => {
            if (x.isRateEdited === true) {
                let obj = {
                    date: new Date().toISOString(),
                    idProcess: data.idProcess,
                    idItem: x.idItem,
                    processRate: x.itemRate,
                    idCompany: this.state.idCompany,
                    e_Date: new Date().toISOString(),
                };
                request.push(obj);
            }
        });
        if (request.length > 0) {
            this.masterEntryServices.saveItemRateProcesswiseInsert(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    this.SwalServices.Success("Save successfully.");
                    this.procSelectAllRecordsSP()
                    this.setState({ isModalOpen: false });
                }
            });
        } else {
            this.SwalServices.Error("Please select at least one row to save.");
        }
    }

    render() {
        return (
            <div className='tax-structure-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <ProcessRatesPopUp
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            processObject={this.state.processObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.getMasterItemSelectForProcessRateRev.bind(this)}
                            validState={this.state.validState}
                            handleChangeFroDropdown={this.handleChangeFroDropdown.bind(this)}
                            save={this.save.bind(this)}
                            setActiveTab={this.setActiveProcessTab.bind(this)}
                            onSelectedRowDoubleClicked={this.onSelectedRowDoubleClicked.bind(this)}
                            rowSelection="multiple"
                            onRowClicked={this.onRowClicked}
                            onCellValueChanged={this.onCellValueChanged}
                            onGridReady={this.onPopupGridReady}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[68vh] w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Process rates</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
